import { render, staticRenderFns } from "./force-upgrade-log.vue?vue&type=template&id=f1c8a1a4"
import script from "./force-upgrade-log.vue?vue&type=script&lang=js"
export * from "./force-upgrade-log.vue?vue&type=script&lang=js"
import style0 from "./force-upgrade-log.vue?vue&type=style&index=0&id=f1c8a1a4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1c8a1a4')) {
      api.createRecord('f1c8a1a4', component.options)
    } else {
      api.reload('f1c8a1a4', component.options)
    }
    module.hot.accept("./force-upgrade-log.vue?vue&type=template&id=f1c8a1a4", function () {
      api.rerender('f1c8a1a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/log-service/force-upgrade-log.vue"
export default component.exports